import {
  GET_PENGURUS_OVERVIEW,
  GET_PENGURUS_OVERVIEW_SUCCESS,
  GET_PENGURUS_OVERVIEW_FAIL,
    GET_PENGURUS_PROVINSI,
    GET_PENGURUS_PROVINSI_SUCCESS,
    GET_PENGURUS_PROVINSI_FAIL,
    GET_PENGURUS_KABKOT,
    GET_PENGURUS_KABKOT_SUCCESS,
    GET_PENGURUS_KABKOT_FAIL,
    GET_PENGURUS_KECAMATAN,
    GET_PENGURUS_KECAMATAN_SUCCESS,
    GET_PENGURUS_KECAMATAN_FAIL,
  } from "./actionTypes";
  
  const initialState = {
    dataPengurusOverview: {
      loading: false,
      error: false,
      data: null,
    },
    dataPengurusProvinsi: {
      loading: false,
      error: false,
      data: null,
    },
    dataPengurusKabkot: {
      loading: false,
      error: false,
      data: null,
    },
    dataPengurusKecamatan: {
      loading: false,
      error: false,
      data: null,
    },
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      // get table exco pusat
      case GET_PENGURUS_PROVINSI:
        return {
          ...state,
          dataPengurusProvinsi: {
            ...state.dataPengurusProvinsi,
            loading: true,
            error: false,
          },
        };
      case GET_PENGURUS_PROVINSI_SUCCESS:
        return {
          ...state,
          dataPengurusProvinsi: {
            ...state.dataPengurusProvinsi,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_PENGURUS_PROVINSI_FAIL:
        return {
          ...state,
          dataPengurusProvinsi: {
            ...state.dataPengurusProvinsi,
            loading: false,
            error: action.payload,
          },
        };
			case GET_PENGURUS_KABKOT:
				return {
					...state,
					dataPengurusKabkot: {
						...state.dataPengurusKabkot,
						loading: true,
						error: false,
					},
				};
			case GET_PENGURUS_KABKOT_SUCCESS:
				return {
					...state,
					dataPengurusKabkot: {
						...state.dataPengurusKabkot,
						loading: false,
						error: false,
						data: action.payload,
					},
				};
			case GET_PENGURUS_KABKOT_FAIL:
				return {
					...state,
					dataPengurusKabkot: {
						...state.dataPengurusKabkot,
						loading: false,
						error: action.payload,
					},
				};
			case GET_PENGURUS_KECAMATAN:
				return {
					...state,
					dataPengurusKecamatan: {
						...state.dataPengurusKecamatan,
						loading: true,
						error: false,
					},
				};
			case GET_PENGURUS_KECAMATAN_SUCCESS:
				return {
					...state,
					dataPengurusKecamatan: {
						...state.dataPengurusKecamatan,
						loading: false,
						error: false,
						data: action.payload,
					},
				};
			case GET_PENGURUS_KECAMATAN_FAIL:
				return {
					...state,
					dataPengurusKecamatan: {
						...state.dataPengurusKecamatan,
						loading: false,
						error: action.payload,
					},
				};
      case GET_PENGURUS_OVERVIEW:
        return {
          ...state,
          dataPengurusOverview: {
            ...state.dataPengurusOverview,
            loading: true,
            error: false,
          },
        };
      case GET_PENGURUS_OVERVIEW_SUCCESS:
        return {
          ...state,
          dataPengurusOverview: {
            ...state.dataPengurusOverview,
            loading: false,
            error: false,
            data: action.payload,
          },
        };
      case GET_PENGURUS_OVERVIEW_FAIL:
        return {
          ...state,
          dataPengurusOverview: {
            ...state.dataPengurusOverview,
            loading: false,
            error: action.payload,
          },
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  